export enum ROLES {
  admin = 'collaborator',
  collaborator = 'limited_collaborator',
  invitee = 'invitee',
  subscriber = 'subscriber',
}
